module.exports = __webpack_public_path__ + "static/media/goods.38a99048.png";